import { render, staticRenderFns } from "./TranslationsCompareView.vue?vue&type=template&id=5d5d5ecc&scoped=true"
import script from "./TranslationsCompareView.vue?vue&type=script&lang=js"
export * from "./TranslationsCompareView.vue?vue&type=script&lang=js"
import style0 from "./TranslationsCompareView.vue?vue&type=style&index=0&id=5d5d5ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d5ecc",
  null
  
)

export default component.exports